import type { ProductCategory } from "../product-category.entity";
import type { ProductSupplier } from "../product-supplier.entity";

function normalize(s: string) {
  return s
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

export function findBestCategoryId(
  label: string | null | undefined,
  categories: ProductCategory[]
): string | null {
  if (!label?.trim()) return null;
  const n = normalize(label);
  const exact = categories.find((c) => normalize(c.title) === n);
  if (exact) return exact.id;
  const partial = categories.find(
    (c) =>
      normalize(c.title).includes(n) ||
      n.includes(normalize(c.title))
  );
  return partial?.id ?? null;
}

export function findBestSupplierId(
  label: string | null | undefined,
  suppliers: ProductSupplier[]
): string | null {
  if (!label?.trim()) return null;
  const n = normalize(label);
  const exact = suppliers.find((s) => normalize(s.title) === n);
  if (exact) return exact.id;
  const partial = suppliers.find(
    (s) =>
      normalize(s.title).includes(n) ||
      n.includes(normalize(s.title))
  );
  return partial?.id ?? null;
}
